<template>
  <nav class="fixed inset-x-0 bottom-0 z-30 flex items-center justify-center h-12 py-4 space-x-4 text-xs font-bold tracking-wide text-white uppercase bg-black xl:h-16 xl:space-x-8 xl:text-sm 2xl:text-lg text-opacity-90 bg-opacity-90">
    <router-link v-for="link in links" :key="link.path" :to="link.path" :class="{ 'pointer-events-none': link.disabled }" active-class="text-secondary-500">
      {{ link.name }}
    </router-link>
  </nav>
</template>

<script>
export default {
  name: 'NavigationMenu',
  data () {
    return {
      links: [
        { name: 'Project Concept', path: '/project-concept' },
        { name: 'Location', path: '/location' },
        { name: 'Project Details', path: '/project-details' },
        { name: 'Master Plans', path: '/master-plans' },
        { name: 'Facilities', path: '/facilities' },
        { name: 'Gallery', path: '/gallery' },
        { name: 'Animation', path: '/animation', disabled: true },
        { name: 'VR Tour', path: '/vr-tour' },
        { name: 'Privileges', path: '/privileges' },
        { name: 'Contact', path: '/contact' },
      ],
    }
  },
}
</script>

<style lang="postcss" scoped>
nav {
  backdrop-filter: blur(8px);
}
</style>
